import React from 'react'
import { ListItem, Row, Separator } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { getSessionId } from '@fs/zion-session'
import noGroupImg from '../upload-page/assets/no-group.jpg'
import CetActions from '../upload-page/upload-row/CetActions'
import { useTreeDetails } from '../upload-page/upload-row/useTreeDetails'
import { useShowLoadingBar } from '../upload-page/upload-row/useShowLoadingBar'

const imageStyleCss = css`
  img {
    border-radius: 8px;
    max-width: 79px;
  }
`

function ManageTreeRow({ name, treeId, id: groupId, fileStatus, percentComplete, types, imageUrl, isMobile, isLast }) {
  const sessionId = getSessionId()
  const { treeDetails } = useTreeDetails(treeId)
  const [{ isImporting, isProcessing }] = useShowLoadingBar({ fileStatus, percentComplete })

  const imageSrc = imageUrl ? `${imageUrl}?sessionId=${sessionId}` : noGroupImg
  const isProcessingOrLoading = isProcessing || isImporting
  const isPrivateTree = treeDetails?.private

  const actions = (
    <CetActions
      groupId={groupId}
      isManageTree
      treeId={treeId}
      fileStatus={fileStatus}
      isProcessingOrLoading={isProcessingOrLoading}
      isPrivateTree={isPrivateTree}
      isResearcherTree={types?.includes('RESEARCHER_TREE')}
      isMobile={isMobile}
    />
  )

  return (
    <>
      <ListItem
        dense={isMobile}
        startElement={
          <div css={imageStyleCss}>
            <ListItem.Image size="md" src={imageSrc} />
          </div>
        }
        primaryText={name}
        endElement={!isMobile ? actions : undefined}
      />
      {isMobile && (
        <>
          <Separator size="pico" />
          <Row>{actions}</Row>
          {!isLast && <Separator size="sm" />}
        </>
      )}
    </>
  )
}

export { ManageTreeRow }
